module.exports = __webpack_public_path__ + "static/img/4.5d5869e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-en/4.jpg
// module id = xSAD
// module chunks = 1